export const STABLE_SESSION_QUERY_OPTIONS = {
  refetchOnFocus: false,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: 300,
} as const;

export const TERMS_STATUS_QUERY_OPTIONS = {
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
} as const;
